import formatter from './field-formatter.js';

/** @typedef { import('synapse-js/src/types/synapse-data-grid').Field } Field */
/** @typedef { import('../types/adapted-device.js').AdaptedDevice } Device */

/**
 *
 * @returns { Object.<string, Field> }
 */
export function getDefaultFields(localization) {
  const getLocalization = localization;

  return {
    premium: {
      type: 'preferred icon center-header shrink',
      name: getLocalization('preferred'),
      header: getLocalization('pro'),
      converter: formatter.preferred,
      columnSelector: false,
    },
    deviceName: {
      type: 'deviceName',
      name: getLocalization('deviceName'),
      converter: formatter.deviceName,
      columnSelector: false,
    },
    hostName: { type: 'hostName', name: getLocalization('host') },
    status: {
      type: 'status',
      name: getLocalization('status'),
      converter: formatter.status,
      sortKeyFn: (_, /** @type {Device} */ data) => `${data.status}-${data.lastSeen}`,
    },
    labels: {
      type: 'labels',
      name: getLocalization('labels'),
      converter: formatter.labelsInTable,
      sortable: false,
    },
    clientVersion: {
      type: 'clientVersion',
      name: getLocalization('version'),
    },
    osName: {
      type: 'osName',
      name: getLocalization('OS'),
      converter: formatter.osName,
    },
    osVersion: { type: 'osVersion', name: getLocalization('OSVersion') },
    ipAddresses: {
      type: 'ipAddresses',
      name: getLocalization('IP'),
      converter: formatter.ipAddresses,
      sortable: false,
    },
    lastLoggedInUser: { type: 'lastLoggedInUser', name: getLocalization('user') },
    lastAccess: {
      type: 'lastAccess',
      name: getLocalization('access'),
      converter: formatter.lastAccess,
    },
  };
}
